module.exports = __webpack_public_path__ + "static/media/tutorial2.72d97b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/tutorial2.png
// module id = 472
// module chunks = 0